<template>
    <span>
        <i :class="dynamicsClass"></i>
    </span>
</template>

<script>
    export default {
        props: {
            icon: {
                type: String,
                required: true
            },
            bkgColor: {
                type: String,
                required: false,
                default: ''
            }
        },
        data(){
            return {
            }
        },
        computed: {
            dynamicsClass(){
                let classes = [
                    this.icon,
                ]
                
                if(this.bkgColor && this.bkgColor != ''){
                    classes.push(`${this.bkgColor}-bkg`)
                    classes.push('icon-with-bkg')
                }
                return classes
            }
        }
    }
</script>

<style scoped lang="scss">
    .icon-with-bkg{
        padding: 4px;
        font-size: 10px;
        border-radius: 4px;
        color: white;
    }
</style>